module.exports = __webpack_public_path__ + "assets/webgl/worms.jpg.81e20622.webp";